import classNames from 'classnames';

import { TwoColumnPromoFragmentFragment } from '../../__generated__/graphql';
import AppImage from '../../components/AppImage';
import Content from '../../components/Content';
import { mapTwoColumnPromoContent } from '../../components/Content/helpers';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './two-column-promo.module.css';

const TwoColumnPromo: ContentBlock<TwoColumnPromoFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.twoColumnPromo;

  if (!contentBlockProps) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.sectionContainer}
    >
      <div
        className={classNames(
          style.contentContainer,
          { [style.contentContainerEvenColumns]: contentBlockProps.columnWidths === 'halfHalf' },
        )}
      >
        <SectionTitle className={style.title}>
          {contentBlockProps.title}
        </SectionTitle>

        {contentBlockProps.image && (
          <AppImage
            fallbackHeight={600}
            fallbackWidth={600}
            image={contentBlockProps.image}
          />
        )}

        {contentBlockProps.content && (
          <div>
            <Content content={mapTwoColumnPromoContent(contentBlockProps.content)} />
          </div>
        )}
      </div>
    </Section>
  );
};

export default TwoColumnPromo;
